export enum MenuType {
    Folder = 1,
    Dynamic = 2,
    System = 3,
    Url = 4,
}